<div class="cm-skeleton-header">
  <!-- Back button (left) -->
  <div class="cm-skeleton-header-back">
    <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 40px; height: 40px; border-radius: 4px;"></div>
  </div>

  <!-- Center content (title and subtitle) -->
  <div class="cm-skeleton-header-content">
    <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 220px;"></div>
    <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 380px; margin-top: 0.25rem;"></div>
  </div>

  <!-- Action button (right) -->
  <div class="cm-skeleton-header-action">
    <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 140px; height: 40px; border-radius: 4px;"></div>
  </div>
</div>
